import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useClassroomRosterChoicePost = () => {
  const setClassroomRosterChoicePost = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v2/roster-choice/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setClassroomRosterChoicePost);
};

export default useClassroomRosterChoicePost;
